/**
 * Monitor API.
 */
import { appList, appCreate, appDestroy } from '../constants/apiRouting'
import { apiConfig } from '../config'
import { AuthenticatedApi } from '../lib/http'

export type App = {
  id: string
  name: string
  created: string
  modified: string
  description: string | null
  icon: string | null
  url: string
  background_image: string | null
  appType: string
}

export class AppsApi {
  constructor(private api: AuthenticatedApi) {}

  list(data: any): Promise<App[]> {
    return this.api.request('GET', appList(), { data }, apiConfig.API_VERSIONS.V1)
  }
  create(data: any) {
    return this.api.request('POST', appCreate(), { data, headers: { 'Content-Type': 'multipart/form-data' } }, apiConfig.API_VERSIONS.V1)
  }
  destroy(appId: string) {
    return this.api.request('DELETE', appDestroy(appId), {}, apiConfig.API_VERSIONS.V1)
  }
}
